import { createContext } from "react";
export const ProductContext = createContext(null);
export const AuthContext = createContext(null);
export const CartContext = createContext(null);
export const WishlistContext = createContext(null);
